"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : ADDABLE FIELDS : STYLES --------------- ++++++++++ */


var _default = {
  addablefields: {
    '& .fields': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      '& .label': {
        marginBottom: (0, _index.pxToEm)(12)
      },
      '& .addablefield': {
        display: 'flex',
        marginBottom: (0, _index.pxToEm)(7),
        '&:last-child': {
          marginBottom: '0'
        },
        '& .field': {
          flex: '1',
          marginRight: (0, _index.pxToEm)(5)
        }
      }
    },
    '& .cta.name-addfield': {
      marginTop: (0, _index.pxToEm)(12)
    }
  }
};
exports.default = _default;